import { ELegalActType } from "./ILocalLaw";

// Wnioski o ogłoszenie aktów w wojewódzkim dzienniku urzędowym (UPE).
// Port kreatora z Magistratu (projekty UPE / UPE.Forms) — z tą różnicą, że logowanie
// do UPE jest tam pierwszym krokiem kreatora, a u nas integracją profilu.

/** Rodzaj wniosku — Kwantum.Enums.LegalActPublicationRequestType. */
export enum EPublicationRequestType {
  /** Wniosek o ogłoszenie aktu (XML) w dzienniku urzędowym. */
  Lapx = 0,
  /** Wniosek o ogłoszenie aktu w innym formacie niż XML. */
  NonLapx = 1,
  /** Wniosek o wycofanie aktu z ogłoszenia. */
  Withdraw = 3,
  /** Wniosek do nadzoru prawnego Regionalnej Izby Obrachunkowej. */
  LapxRio = 4,
  /** Pismo z dodatkowymi dokumentami do procesu nadzoru RIO. */
  LapxRioProtocol = 5,
}

/** Stan wniosku — Kwantum.LegalMail.Core.Enums.LegalActPublicationRequestStatus. */
export enum EPublicationRequestStatus {
  Draft = 0,
  AwaitingSignature = 1,
  Signed = 2,
  Sent = 3,
  Error = 4,
}

export interface IPublicationRequestItem {
  LegalActId: string;
  ActType: ELegalActType;
  ActTypeName: string;
  ActNumber?: string | null;
  Title?: string | null;
  Date?: string | null;
}

export interface IPublicationRequest {
  Id: string;
  Type: EPublicationRequestType;
  TypeName: string;
  Signature?: string | null;
  RequestDate?: string | null;
  Status: EPublicationRequestStatus;
  StatusName: string;
  UpeIssueId?: number | null;
  SenderName?: string | null;
  RecipientName?: string | null;
  IsSigned: boolean;
  SignedDate?: string | null;
  SentDate?: string | null;
  LastError?: string | null;
  CreationDate: string;
  HasPackage: boolean;
  Items: IPublicationRequestItem[];
}

export interface IUpeAccount {
  Configured: boolean;
  SystemOfficeName?: string | null;
  OfficeName?: string | null;
  Login?: string | null;
  InstitutionName?: string | null;
  UserName?: string | null;
  LastSync?: string | null;
  LastError?: string | null;
}

export interface IUpeReceiver {
  Id: number;
  Name?: string | null;
  City?: string | null;
  IsDefault: boolean;
}

export interface IPublicationContext {
  Account: IUpeAccount;
  SenderName?: string | null;
  EmployeeName?: string | null;
  Receivers: IUpeReceiver[];
  Acts: IPublicationRequestItem[];
  /** Komunikat, gdy nie udało się porozmawiać z UPE — kreator nie pozwala wtedy iść dalej. */
  Warning?: string | null;
}

export interface ICreatePublicationRequest {
  Type: EPublicationRequestType;
  Signature?: string;
  RequestDate?: string;
  RecipientInstitutionId?: number;
  RioInstitutionId?: number;
  LegalActIds: string[];
  EmployeeFirstName?: string;
  EmployeeLastName?: string;
  EmployeePosition?: string;
}
